<script lang="ts">
  const { size = 24 }: { size?: string | number } = $props();
</script>
<svg
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  transform="translate(1,0)"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
     x="5"
     y="4"
     width="16"
     height="14"
     rx="2"
     ry="2"
     style="stroke-width:2" />
  <path
     d="M 17,21 H 4 c -1.108,0 -2,-0.892 -2,-2 V 9" />
  <line
     x1="17"
     y1="2"
     x2="17"
     y2="6"
   />
  <line
     x1="9"
     y1="2"
     x2="9"
     y2="6"
   />
  <g
     id="g5">
    <path
       transform="translate(1)"
       d="m 9,12 3,3 3,-3" />
    <path
       d="M 13,14.272738 V 8.5937667" />
  </g>
</svg>
